import React from 'react';
import {
    Box,
} from '@mui/material';

const RequiredDocuments = ({policyData}) => {

    const [requiredDocs, setRequiredDocs] = React.useState([]);

    React.useEffect(() => {

        if (policyData?.required_documents && policyData?.required_documents?.length>0) {
            setRequiredDocs(policyData?.required_documents);
        }

    }, [policyData?.required_documents]);


    return (
        <Box>
            {policyData?.required_documents && policyData?.required_documents?.length>0 && (<><h3 className="sectionHeading" style={{marginTop: '10px'}}>REQUIRED DOCUMENTS</h3>
            <div className="preview-header-section">
                {requiredDocs.length===0 ? <p>No Data</p> : 
                    (<ul style={{ listStyle: 'disc', "marginLeft": "15px", "paddingLeft": "0", 'marginTop': '0', marginBottom: '0' }}>
                        {
                            requiredDocs?.map((item, index) => {
                                return <li key={index} style={{"paddingBottom":"3px", "marginLeft": "0", "paddingLeft": "0"}}> {item} </li>
                            })
                        }
                    </ul>)
                }
            </div></>)}           
        </Box>
    )

}

export default RequiredDocuments;